import React from 'react';
import { calculaPrevision, formatMs, getControlById } from '../utils/time';

const ResultadoDetailTablaPasos = ({ resultado, prevision, competicion, controlList, sectores }) => {

  // Calcular el tiempo de inicio del corredor
  let tiempoInicioCorrector = 0;
  if (competicion.tipo === 'TIEMPONETO' && resultado.start) {
    tiempoInicioCorrector = resultado.start - (competicion.guntime || 0);
  } else {
    tiempoInicioCorrector = 0;
  }

  let ultimoSector = null;
  if (sectores && sectores.length) {
    sectores.forEach(sector => {
      sector.fin_metros = 0;
      sector.inicio_metros = 0;
      if (sector.inicio) {
        const inicio = getControlById(controlList, sector.inicio);
        if (inicio) {
          sector.incio_control = inicio;
          sector.inicio_metros = inicio.distancia;
        }
      }
      const fin = getControlById(controlList, sector.fin);
      if (fin) {
        sector.fin_control = fin;
        sector.fin_metros = fin.distancia;
      }
    });
  }

  const _getSectorActual = (control) => {
    return sectores.find(sector => sector.inicio_metros < control.distancia && sector.fin_metros >= control.distancia);
  };

  // Encontrar el último control por el que pasó el corredor
  let ultimoControlPasado = null;
  if (controlList && controlList.length > 0) {
    const controlesOrdenados = [...controlList].sort((a, b) => b.distancia - a.distancia);
    for (const ctrl of controlesOrdenados) {
      const tiempoEnControl = resultado['control_' + ctrl.id + '_tiempo'];
      if (tiempoEnControl) {
        ultimoControlPasado = ctrl;
        break;
      }
    }
  }

  if (controlList) {
    return (
      <div className="w-full pb-6">
        <div className="mx-auto max-w-5xl px-4 md:px-40">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b border-slate-700">
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                    Control
                  </th>
                  <th className="text-right py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                    Pos.
                  </th>
                  <th className="text-right py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                    Tiempo
                  </th>
                  <th className="text-right py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                    Ritmo
                  </th>
                </tr>
              </thead>
              <tbody>
                {controlList.map((control) => {
                  const tiempoAbsoluto = resultado['control_' + control.id + '_tiempo'];
                  const tiempo = tiempoAbsoluto ? (tiempoAbsoluto - tiempoInicioCorrector) : null;
                  const puesto = resultado['control_' + control.id + '_puesto'];

                  let estaPrevision = null;
                  if (sectores && sectores.length) {
                    let d0 = 0;
                    let d1 = 0;
                    if (prevision.sector && prevision.sector.inicio) {
                      const inicio = getControlById(controlList, prevision.sector.inicio);
                      if (inicio) {
                        d0 = inicio.distancia;
                      }
                    }
                    if (prevision.sector) {
                      const fin = getControlById(controlList, prevision.sector.fin);
                      if (fin) {
                        d1 = fin.distancia;
                      }
                    }
                    if (d0 <= control.distancia && d1 >= control.distancia) {
                      if (prevision.control && prevision.control.id === control.id) {
                        if (!ultimoControlPasado || control.distancia > ultimoControlPasado.distancia) {
                          estaPrevision = prevision;
                        }
                      } else {
                        if (control.prevision) {
                          if (!ultimoControlPasado || control.distancia > ultimoControlPasado.distancia) {
                            estaPrevision = calculaPrevision(competicion, controlList, sectores, resultado, control);
                          }
                        }
                      }
                    }
                  } else {
                    if (prevision.control && prevision.control.id === control.id) {
                      if (!ultimoControlPasado || control.distancia > ultimoControlPasado.distancia) {
                        estaPrevision = prevision;
                      }
                    } else {
                      if (control.prevision) {
                        if (!ultimoControlPasado || control.distancia > ultimoControlPasado.distancia) {
                          estaPrevision = calculaPrevision(competicion, controlList, sectores, resultado, control);
                        }
                      }
                    }
                  }

                  let ritmo = tiempo ? formatMs(tiempo / control.distancia * 1000) : '---';
                  let ritmoTiempo = tiempo;
                  let trHeaderSector = null;

                  if (sectores && sectores.length) {
                    const sector = _getSectorActual(control);
                    if (sector) {
                      if (tiempo) {
                        if (sector.inicio && resultado['control_' + sector.inicio + '_tiempo']) {
                          ritmoTiempo = tiempo - resultado['control_' + sector.inicio + '_tiempo'];
                        }

                        if (sector.resultados_ritmo) {
                          let ritmoDistancia = control.distancia;
                          if (sector.inicio) {
                            ritmoDistancia = control.distancia - sector.inicio_metros;
                          } else if (!sector.incio_control) {
                            // Se non hai control de inicios pensamos que desde a salida.
                          } else {
                            ritmo = '---';
                            ritmoTiempo = 0;
                          }

                          if (ritmoTiempo) {
                            if (sector.resultados_ritmo === 'RUNNING') {
                              ritmo = formatMs(ritmoTiempo / ritmoDistancia * 1000) + ' min/km';
                            } else if (sector.resultados_ritmo === 'BICI') {
                              ritmo = (ritmoDistancia / (ritmoTiempo / 60 / 60)).toFixed(2) + ' km/h';
                            } else if (sector.resultados_ritmo === 'NATACION') {
                              ritmo = formatMs(ritmoTiempo / ritmoDistancia * 100) + ' min/100m';
                            }
                          }
                        } else {
                          ritmo = '---';
                        }
                      }

                      if (!ultimoSector || sector.id !== ultimoSector.id) {
                        let tiempoEnSector = 0;
                        if (sector.fin && resultado['control_' + sector.fin + '_tiempo']) {
                          tiempoEnSector = resultado['control_' + sector.fin + '_tiempo'];
                        }
                        if (sector.inicio && resultado['control_' + sector.inicio + '_tiempo']) {
                          tiempoEnSector -= resultado['control_' + sector.inicio + '_tiempo'];
                        }

                        trHeaderSector = (
                          <tr key={`sector-${sector.id}`}>
                            <td colSpan={4} className="py-3 px-4 bg-slate-800/50 border-t border-b border-slate-700">
                              <div className="flex items-center gap-2 font-montserrat text-sm">
                                <span className="font-semibold text-white">{sector.nombre}</span>
                                {tiempoEnSector > 0 && (
                                  <span className="text-slate-300 font-mono">
                                    {formatMs(tiempoEnSector)}
                                  </span>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                        ultimoSector = sector;
                      }
                    } else if (competicion.resultados_ritmo && tiempo) {
                      if (competicion.resultados_ritmo === 'RUNNING') {
                        ritmo = formatMs(tiempo / control.distancia * 1000) + ' min/km';
                      } else if (competicion.resultados_ritmo === 'BICI') {
                        ritmo = (control.distancia / (tiempo / 60 / 60)).toFixed(2) + ' km/h';
                      } else if (competicion.resultados_ritmo === 'NATACION') {
                        ritmo = formatMs(tiempo / control.distancia * 100) + ' min/100m';
                      }
                    }
                  } else {
                    if (competicion.resultados_ritmo && tiempo) {
                      if (competicion.resultados_ritmo === 'RUNNING') {
                        ritmo = formatMs(tiempo / control.distancia * 1000) + ' min/km';
                      } else if (competicion.resultados_ritmo === 'BICI') {
                        ritmo = (control.distancia / (tiempo / 60 / 60)).toFixed(2) + ' km/h';
                      } else if (competicion.resultados_ritmo === 'NATACION') {
                        ritmo = formatMs(tiempo / control.distancia * 100) + ' min/100m';
                      }
                    }
                  }

                  return (
                    <React.Fragment key={control.id}>
                      {trHeaderSector}
                      <tr className="border-b border-slate-800 hover:bg-slate-900/30 transition">
                        <td className="py-3 px-4">
                          <div className="text-white font-medium font-montserrat text-sm">
                            {control.nombre}
                          </div>
                          {control.descripcion && (
                            <div className="text-xs text-slate-500 font-montserrat mt-1">
                              {control.descripcion}
                            </div>
                          )}
                        </td>
                        <td className="text-right py-3 px-4 text-slate-300 font-montserrat text-sm">
                          {puesto || '---'}
                        </td>
                        <td className="text-right py-3 px-4 text-white font-mono text-sm">
                          {tiempo ? (
                            <span>{formatMs(tiempo)}</span>
                          ) : (
                            (!competicion.carrera_finalizada && estaPrevision && estaPrevision.tiempoTotal) ? (
                              <div>
                                <span className="text-red-400">{formatMs(estaPrevision.tiempoTotal)}</span>
                                <div className="text-xs text-slate-500 mt-1 uppercase">(previsión)</div>
                              </div>
                            ) : (
                              <span className="text-slate-500">---</span>
                            )
                          )}
                        </td>
                        <td className="text-right py-3 px-4 text-slate-300 font-mono text-sm">
                          {ritmo}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  } else {
    return <div />;
  }
};

export default ResultadoDetailTablaPasos;